import { FC, ReactElement } from 'react';

import { useCoreDispatch } from '../../../store'; // ToDo: Will not work with Core-0.42.. Fix on Merge
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const PromoRoundLimitConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const title = usePopupSlice.customTitleForPopup() ?? '';
  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        dispatch(popupActions.dismissPopup(PopupType.PromoRoundLimit));
      },
    },
  ];

  return <BlockingModalContent customTitle={title} messageTk="DAILY_TOURNAMENT_LIMIT" actions={action} />;
};
